import List from "@mui/material/List";
import { AppBar } from "@mui/material";
import SideBar from "rc-material-sidebar";
import SpeedIcon from "@mui/icons-material/Speed";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import FolderIcon from "@mui/icons-material/Folder";
import { useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const AdminSidebar = ({ open }) => {
  const navigate = useNavigate();

  const onClick = (e, item) => {
    if (item.cbUrl) {
      navigate(item.cbUrl, { state: "add" });
      return;
    }
  };

  const items = [
    {
      key: "1",
      label: "Dashboard",
      link: "/app",
      icon: <DashboardIcon sx={{ width: "34px" }} />,
    },
    {
      key: "2",
      label: "Case Studies",
      link: "/app/case-studies",
      icon: <MenuBookIcon sx={{ width: "34px" }} />,
      activeChildrenPath: ["/app/add-case-studies"],
    },
    {
      key: "3",
      label: "File Manager",
      link: "/app/file-manager",
      icon: <FolderIcon sx={{ width: "34px" }} />,
    },
    {
      key: "4",
      label: "Profile",
      link: "/app/user-profile",
      icon: <AccountCircleIcon sx={{ width: "34px" }} />,
    },
    // {
    //   key: "2",
    //   label: "Forms",
    //   link: "/app/forms",
    //   icon: <ChecklistIcon sx={{ width: "34px" }} />,
    //   activeChildrenPath: ["/app/addForm", "/app/sumbission"],
    // },
    // {
    //   key: "2",
    //   label: "Case Studies",
    //   // link: "/app/forms",
    //   icon: <ChecklistIcon sx={{ width: "34px" }} />,
    //   children: [
    //     {
    //       key: "3",
    //       label: "All Case Studies",
    //       link: "/app/case-studies",
    //     },
    //     {
    //       key: "4",
    //       label: "Add case-studies",
    //       // cbUrl: "/app/add-case-studies",
    //       link: "/app/add-case-studies",
    //     },
    //   ],
    // },
  ];

  return (
    <AppBar
      position="fixed"
      component="div"
      color="transparent"
      elevation={0}
      sx={{
        width: open ? 240 : 66,
        right: "inherit",
        height: "calc(100% - 64px)",
        top: 64,
      }}
      className={open ? "full" : "mini"}
    >
      <List className="sidebarMenu">
        <SideBar
          items={items}
          variant={open ? "full" : "mini"}
          onClick={onClick}
        />
      </List>
    </AppBar>
  );
};

export default AdminSidebar;
